import {
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import C1InputField from "app/c1component/C1InputField";



const RaeoAppAssessmentItem = ({
  assess,
  isDisabled,
  errors,
  handleInputChangeCommon,
  handleCheckboxChange
}) => {

 let fieldType = null;

 if (assess?.TSctRaeoMstAssessment?.asmFieldAttribute) {
  try {
    const asmFieldAttribute = JSON.parse(assess.TSctRaeoMstAssessment.asmFieldAttribute);
    fieldType = asmFieldAttribute.fieldType;
  } catch (error) {
    console.error('Error parsing asmFieldAttribute:', error);
  }
}

  const TextComponent = () => {
    return (
      <C1InputField
        label="Response"
        name="apasResponse"
        value={assess.apasResponse || ""}
        multiline
        rows={3}
        required
        disabled={isDisabled}
        onChange={(e) => handleInputChangeCommon(e, assess.apasId)}
        inputProps={{ maxLength: 1024 }}
        error={
          errors[`TSctRaeoAppAssessments[${assess.apasId}].apasResponse`] !==
          undefined
        }
        helperText={
          errors[`TSctRaeoAppAssessments[${assess.apasId}].apasResponse`] || ""
        }
      />
    );
  };

  const NumComponnet = () => {
    return (
      <C1InputField
        label="Response"
        name="apasResponse"
        value={assess.apasResponse || ""}
        required
        type="number"
        disabled={isDisabled}
        onChange={(e) => handleInputChangeCommon(e, assess.apasId)}
        inputProps={{
          maxLength: 12,
          min: "0",
          max: "999999999999.99",
        }}
        error={
          errors[`TSctRaeoAppAssessments[${assess.apasId}].apasResponse`] !==
          undefined
        }
        helperText={
          errors[`TSctRaeoAppAssessments[${assess.apasId}].apasResponse`] || ""
        }
      />
    );
  };

  const RadioComponent = () => {
    return (
      <FormControl component="fieldset">
        <RadioGroup
          row
          aria-label="apasResponse"
          name="apasResponse"
          value={assess.apasResponse}
          onChange={(e) => handleCheckboxChange(e, assess.apasId)}
          error={
            errors[`TSctRaeoAppAssessments[${assess.apasId}].apasResponse`] !==
            undefined
          }
          helperText={
            errors[`TSctRaeoAppAssessments[${assess.apasId}].apasResponse`] ||
            ""
          }
        >
          <FormControlLabel
            value="Y"
            control={<Radio color="primary" />}
            label="Yes"
            disabled={isDisabled}
          />
          <FormControlLabel
            value="N"
            control={<Radio color="secondary" />}
            label="No"
            disabled={isDisabled}
          />
        </RadioGroup>
      </FormControl>
    );
  };

  const RadioExtComponent = () => {
    return (
      <FormControl component="fieldset">
        <RadioGroup
          row
          aria-label="apasResponse"
          name="apasResponse"
          value={assess.apasResponse?.split(":")[0] || ""}
          onChange={(e) => {
            const selectedValue = e.target.value;
            const reason = assess.apasResponse?.split(":")[1] || "";
            handleInputChangeCommon(
              {
                target: {
                  name: "apasResponse",
                  value: `${selectedValue}:${reason}`,
                },
              },
              assess.apasId
            );
          }}
        >
          <FormControlLabel
            value="Y"
            control={<Radio color="primary" />}
            label="Yes"
            disabled={isDisabled}
          />
          <FormControlLabel
            value="N"
            control={<Radio color="secondary" />}
            label="No"
            disabled={isDisabled}
          />
        </RadioGroup>
        <C1InputField
          label="Response"
          name="apasResponseReason"
          value={assess.apasResponse?.split(":")[1] || ""}
          multiline
          rows={3}
          required
          disabled={isDisabled}
          onChange={(e) => {
            const reason = e.target.value || "";
            const selectedValue = assess.apasResponse?.split(":")[0] || "";
            handleInputChangeCommon(
              {
                target: {
                  name: "apasResponse",
                  value: `${selectedValue}:${reason}`,
                },
              },
              assess.apasId
            );
          }}
          inputProps={{ maxLength: 1024 }}
          error={
            errors[`TSctRaeoAppAssessments[${assess.apasId}].apasResponse`] !== undefined
          }
          helperText={
            errors[`TSctRaeoAppAssessments[${assess.apasId}].apasResponse`] || ""
          }
        />
      </FormControl>
    );
  };

  let comp;

  if (assess?.TSctRaeoMstAssessment?.asmIsQuestion !== 0) {
    switch (fieldType) {
      case "NUM":
        comp = NumComponnet();
        break;
      case "RADIO":
        comp = RadioComponent();
        break;
      case "RADIOEXT":
        comp = RadioExtComponent();
        break;

      default:
        comp = TextComponent();
    }
  }

  return (
    <React.Fragment>
      {comp}
    </React.Fragment>
  );
};

export default RaeoAppAssessmentItem;
